import { format } from 'date-fns';
import { Box } from 'components/ui';

const FormattedDate = ({ date, component = "span", warning = false, error = false, emptyComponent = null }) => {
  if (!date) {
    return emptyComponent;
  }

  const parsedDate = new Date(date);
  
  return (
    <Box
      component={component}
      sx={{ display: 'inline' }}
      color={error ? 'error.main' : warning ? 'warning.main' : 'text.primary'}
    >
      {format(parsedDate, 'dd.MM.yyyy')}
    </Box>
  );
};

export default FormattedDate;
